import { createFileRoute } from '@tanstack/react-router'
import { WorkspaceRouteShell } from '@/components/app/route-shells'
import { OperatorWorkspaceRouteGate } from '@/components/operator/operator-workspace-route-gate'
import { ServicesWorkspace } from '@/components/operator/services-workspace'
import { useOperatorConfiguration } from '@/lib/operator-config/use-operator-configuration'
import type { RouteStaticData } from '@/lib/router/breadcrumbs'

export const Route = createFileRoute('/_app/services')({
  component: ServicesPage,
  staticData: {
    breadcrumbs: [{ label: 'Services' }],
  } satisfies RouteStaticData,
})

function ServicesPage() {
  const { configuration, isLoading, error, refreshAll } = useOperatorConfiguration()

  return (
    <WorkspaceRouteShell>
      <OperatorWorkspaceRouteGate
        configuration={configuration}
        isLoading={isLoading}
        error={error}
        onRetry={refreshAll}
        loadingCopy="Loading services…"
        resourceLabel="services"
        noOperatorTitle="Set up your business before adding services."
        noOperatorDescription="Complete setup first so your offering catalog and pricing can be saved correctly."
      >
        <ServicesWorkspace />
      </OperatorWorkspaceRouteGate>
    </WorkspaceRouteShell>
  )
}
